import gql from 'graphql-tag';
import { graphql } from '@apollo/react-hoc';
import get from 'lodash/get';
import UnderstandingYourSubscription from './UnderstandingYourSubscription';
import { SimpleLoadingComponent } from '../../utils/apollo';
import { sortSubscriptions } from './utils';

export const query = gql`
  query AMSubscriptions {
    viewer {
      id
      heAccount {
        id
        activeSubscriptions
        activeMatchSubscriptions {
          edges {
            node {
              id
              version
              institution
              type
              majors
              connection
              academicThreshold {
                enabled
              }
              startDate
              endDate
              visible
              messages {
                competitors {
                  scid
                  name
                }
              }
              audience {
                diversity
                zipCode {
                  zipCode
                  radius
                }
                state
                county {
                  state
                  county
                }
                sector
              }
            }
          }
        }
      }
    }
  }
`;

const data = graphql(query, {
  props: ({ data: _, ownProps }) => {
    const subscriptions = get(_, 'viewer.heAccount.activeMatchSubscriptions.edges', []);
    const sortedSubs = sortSubscriptions(subscriptions);
    const activeSubscriptions = get(_, 'viewer.heAccount.activeSubscriptions', []);
    return {
      ...ownProps,
      subscriptions: sortedSubs,
      activeSubscriptions,
    };
  },
});

export default SimpleLoadingComponent(data)(UnderstandingYourSubscription);
